'use client';
import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';
import { CURSOR_HIDE, CURSOR_STICKY, DispatchCursor } from 'haspr-cursor';

const Hamburger = ({open}) => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;
    const dispatch = DispatchCursor()

    return (
        <StyledHamburger className={`menu-hamburger ${open ? 'open' : ''}`}  >
            <div className="text-content">

                <p style={{color: open ? '#152637' : 'white'}}>{open ? 'Close' : 'Menu'}</p>
            </div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2" cy="2" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
                <circle cx="2" cy="2" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
                <circle cx="2" cy="10" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
                <circle cx="2" cy="18" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
                <circle cx="10" cy="2" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
                <circle cx="10" cy="10" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
                <circle cx="10" cy="18" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
                <circle cx="18" cy="2" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
                <circle cx="18" cy="10" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
                <circle cx="18" cy="18" r="2" fill={`${open ? '#152637' : open && isMobile ? 'white' : 'white' }`} />
            </svg>

        </StyledHamburger>
    );
};
const StyledHamburger = styled.div`
    cursor: pointer;
    display: inline-flex;
    transition: ${theme.transition};
    gap: 15px;
    position: relative;

    &.open{
        svg{
            transform: rotate(45deg);
            circle{
                &:nth-of-type(3),  &:nth-of-type(5),  &:nth-of-type(7),  &:nth-of-type(9){
                    opacity: 0;
                }
            }
        }
        &:hover{
            svg{
                transform: rotate(0);
            }
        }
    }
    @media(max-width: 767px){
        svg{
            circle{
                fill : white !important;
            }
        }
    }
    .text-content {
        position: relative;
        z-index: 3;
        color: ${theme.colors.white};

        p{
            font-weight: 600;
            font-size: 1rem;       /* 16px ÷ 16 */
            line-height: 1.25rem;  /* 20px ÷ 16 */
            letter-spacing: 0;     /* 0% = normal spacing */
            transition: ${theme.transition};
            @media(max-width: 1024px){
                color: ${theme.colors.white} !important;

            }
        }
    }

    svg{
        transition: ${theme.transition};
        circle{
            transition: ${theme.transition};

        }
    }

    &:after, &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        transition-duration: .4s;
        transition-timing-function: cubic-bezier(.25,.74,.22,.99);
        transition-property: transform, background-color, border-color, box-shadow;
    }

    &:hover {
        //gap: 5px;
        &:after {
            width: 100%;
            height: 100%;
            opacity: 1;
        }
        p{
            color: #DD223F !important;
            @media(max-width: 767px){
                color: #fff !important;

            }
        }
        svg{
            transform: rotate(45deg);
            circle{
                fill: #DD223F;
                @media(max-width: 767px){
                    fill: #fff !important;

                }
                &:nth-of-type(3),  &:nth-of-type(5),  &:nth-of-type(7),  &:nth-of-type(9){
                    opacity: 0;
                }
            }
        }
    }

`
export default Hamburger;